import React from 'react';
import {
  getAssets,
  getConfigFile,
  setFilteredAssets,
  setFilters
} from '../actions';
import { connect } from 'react-redux';
import FormFilter from '../components/Filter';

const FilterContainerNew = state => {
  return state.assets !== [] && state.configFile !== undefined ? (
    <div>
      <FormFilter state={state} configFile={state.configFile} />
    </div>
  ) : (
    ''
  );
};

const mapStateToProps = state => ({
  assets: state.assets,
  configFile: state.configFile,
  filters: state.filters,
  filteredAssets: state.filteredAssets
});

const mapDispatchToPropsActions = dispatch => ({
  Assets: (value) => dispatch(getAssets(value)),
  ConfigFile: (value) => dispatch(getConfigFile(value)),
  Filters: value => dispatch(setFilters(value)),
  FilteredAssets: value => dispatch(setFilteredAssets(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToPropsActions
)(FilterContainerNew);
